<ng-select
  [items]="items"
  [multiple]="multiple"
  [clearable]="true"
  [formControl]="ctrl"
  [virtualScroll]="true"
  [closeOnSelect]="false"
  appendTo="body"
  [bindValue]="bindValue"
  [bindLabel]="bindLabel"
  [placeholder]="placeholder"
>

  <ng-template ng-header-tmp>
    <input style="width: 100%; line-height: 24px" type="text" (input)="onFilter($event.target.value)" />
  </ng-template>

  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" let-toggleItem="toggleItem">
    <mat-checkbox [checked]="item$.selected" class="preview-block">{{item.name}}</mat-checkbox>
  </ng-template>

  <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
    <div [attr.data-before]="items | ngSelectEclipsedValue:'name'" class="ng-select-elipsis"></div>
  </ng-template>

</ng-select>
